import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import { makeStyles } from "@material-ui/core/styles";
import SystemContext from "../../SystemContext";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import AirportList from "./components/AirportList";
import AirportStyles from "./styles/AirportStyles";
import AirportDetailsForm from "./components/AirportDetailsForm";
import {Toolbar} from "@material-ui/core";
import ChromeTabs from "../../controls/ChromeTabs";
import AirportCostList from "./components/AirportCostList";
import AirportsLastMovement from "./components/AirportsLastMovement.js";
import {useAirportsLastMovement} from "../../services/aircraft";
import moment from "moment";
import { useQueryClient } from "react-query";
import useAirportCostDates from "../../services/airports/useAirportCostDates";

const AccessControl = require ("../../AccessControl");

function Airports(props) {
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const classes = makeStyles(AirportStyles)();
  const queryClient = useQueryClient();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage SETTINGS", "Manage AIRPORTS"]);
  const canEditCosts = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage COSTING TEMPLATE"]);
  const canViewAirportCosts = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage COSTING TEMPLATE", "View AIRPORT COSTS"]);

  const [state, setState] = useState({
    selectedRecord: null,
    flattenList: false
  });

  const airportExtraKeys = [state.selectedRecord?state.selectedRecord.airportCode:"---"];
  const airportsLastMovement = useAirportsLastMovement({queryClient, extraKeys: airportExtraKeys});
  const airportCostDates = useAirportCostDates({queryClient, extraKeys: airportExtraKeys});

  const {oldestCostingDate, newestCostingDate} = airportCostDates?.data || {};

  const tabs = [
    {label: "Details", value: "details"}
  ]
  if (canViewAirportCosts) {
    tabs.push({label: newestCostingDate?`Costs (${moment.utc(newestCostingDate).format("DD MMM YYYY")})`:`Costs`, value: "costs"});
  }
  if (airportsLastMovement && airportsLastMovement.data) {
    tabs.push({label: `Last Movement (${moment.utc(airportsLastMovement.data.actualMovementTimeUTC).format("DD MMM YYYY")})`, value: "movement"});
  } else {
    tabs.push({label: "Last Movement", value: "movement"});
  }
  const [currentTab, setCurrentTab] = useState("details");

  const handleTabChange = (e, i) => {
    setCurrentTab(i);
  }

  useEffect(() => {
    if (state.selectedRecord) {
      if (eventBus) {
        eventBus.trigger('AirportList.rowSelected', state.selectedRecord);
      }
    }
  }, [currentTab, eventBus, state.selectedRecord]);

  const changeSelectedRecord = (selectedRecord) => {
    setState({...state, selectedRecord: selectedRecord});
  }

  useEffect(() => {
    const handleRowSelected = (record) => {
      changeSelectedRecord(record);
    }

    if (eventBus) {
      eventBus.bind('AirportList.rowSelected', handleRowSelected);
      return ()=>{
        eventBus.unbind('AirportList.rowSelected', handleRowSelected);
      }
    }
  }, [eventBus])

  const listWidth = 475;

  return (isAuthenticated &&
    <div
      className="AirportHeader"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="airports"
        pageName="Airports"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, maxHeight: `calc(100vh - ${(99+2+10+57+4)}px)`}}
      >
        <div style={{display: "flex"}}>
          <div style={{display: "inline-flex", width: listWidth, maxWidth: listWidth, minWidth: listWidth}}>
            <AirportList canEdit={canEdit} classes={classes} height={99+2+10+57}/>
          </div>

          <div style={{display: "block", marginTop: -14}}>
            <Toolbar >
              <ChromeTabs
                id={"CompanyDetails"}
                //style={{ alignSelf: "flex-end", display: "inline-block", align: "left" }}
                style={{ marginTop: 10 }}
                tabs={tabs}
                tabStyle={{
                  bgColor: "#E6E8EB",
                  selectedBgColor: "#ffffff",
                  color: "rgba(0,0,0,0.87)",
                }}
                tabProps={{
                  disableRipple: false,
                }}
                value={currentTab}
                onChange={handleTabChange}
              />
            </Toolbar>
            <div style={{width: "100%"}}>
              { currentTab === "movement"
              ? <div style={{display: "inline-flex", width: "calc(100vw - 550px)", height: "calc(100vh - 220px)", maxHeight: "calc(100vh - 220px)", backgroundColor: "#ffffff"}}>
                <AirportsLastMovement classes={classes} height={99+2+10+57} />
              </div>
              :
                currentTab === "details"
                ?
                <div style={{display: "inline-flex", width: "calc(100vw - 550px)", height: "100%", backgroundColor: "#ffffff"}}>
                  <AirportDetailsForm canEdit={canEdit} classes={classes} />
                </div>
                :
                <div style={{display: "inline-flex", width: "calc(100vw - 550px)", height: "calc(100vh - 220px)", maxHeight: "calc(100vh - 220px)", backgroundColor: "#ffffff"}}>
                  <AirportCostList canEdit={canEditCosts} classes={classes} height={99+2+10+57} flattenList={false} />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default Airports;
